import { render } from "./StaffEnrollmentView.vue?vue&type=template&id=1b51fbd0"
import script from "./StaffEnrollmentView.vue?vue&type=script&lang=js"
export * from "./StaffEnrollmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__